import React from 'react';
import { Link } from 'react-router-dom';

const BrandLogo = ({ light = false }) => (
  <Link
    to="/"
    className="group inline-flex items-center gap-3"
    aria-label="Realizzazione Siti Web Napoli — Home"
  >
    <svg
      className="h-12 w-12 flex-shrink-0 transition-transform duration-300 group-hover:scale-105"
      viewBox="0 0 64 64"
      role="img"
      aria-labelledby="brand-logo-title"
    >
      <title id="brand-logo-title">Logo Realizzazione Siti Web Napoli</title>
      <defs>
        <linearGradient id="brand-mark-gradient" x1="8" y1="8" x2="56" y2="56">
          <stop offset="0%" stopColor="#32b9ed" />
          <stop offset="100%" stopColor="#0B4C8C" />
        </linearGradient>
      </defs>
      <rect x="2" y="2" width="60" height="60" rx="19" fill="url(#brand-mark-gradient)" />
      <path
        d="M19 45V19l26 26V19"
        fill="none"
        stroke="white"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="6"
      />
      <path
        d="M43 13h8v8"
        fill="none"
        stroke="#FFD700"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="4"
      />
      <circle cx="49" cy="15" r="2" fill="#FFD700" />
    </svg>

    <span className="flex flex-col leading-tight">
      <span className={`font-poppins text-base font-bold transition-colors sm:text-lg ${light ? 'text-white' : 'text-napoli-blu group-hover:text-napoli-azzurro'}`}>
        Realizzazione Siti Web
      </span>
      <span className="mt-1 text-xs font-bold uppercase tracking-[0.2em] text-napoli-azzurro">
        Napoli
      </span>
    </span>
  </Link>
);

export default BrandLogo;